<div class="common-table-style">
  <div class="header-box">
    <div class="d-flex align-items-center heading-box">
      <ng-icon name="heroClipboardDocumentCheck"></ng-icon>
      <h2>Contract Types</h2>
    </div>
    <div class="d-flex justify-content-between align-items-center col-md-6 p-0">
      <div class="dense-4 search-and-filter">
        <mat-form-field appearance="outline" class="w-100">
          <mat-label>Search Contract Type</mat-label>
          <input matInput (keyup)="applyFilter($event.target.value)" autocomplete="off">
          <mat-icon matSuffix><ng-icon name="hero"></ng-icon></mat-icon>
        </mat-form-field>
      </div>
      <button color="accent" mat-raised-button [disabled]="!userService.permissionsValue['_CONTRACT_TYPE_ADD_']"
        [routerLink]="['/app/contract-type/add']">
        Add Contract Type </button>
    </div>
  </div>
  <div class="inner-box">
    <mat-table [dataSource]="dataSource" matSort (matSortChange)="customSortData($event)">
      <ng-container matColumnDef="Contract Type">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Contract Type</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <a mat-button color="accent" disableRipple
            [routerLink]="['/app/contract-type', 'view', element.contractTypeId]"
            matTooltip="View Contract Type {{element.name | titlecase}}" [matTooltipShowDelay]="300"
            [matTooltipHideDelay]="100">{{ element.name | titlecase }}</a>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Created By">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Created By</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.createdBy }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="Last Updated">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Last Updated</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.updatedDate }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Version No">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Version No</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.version }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Status">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <span class="status-pill" [ngClass]="
          element.status == 'Approved' ? 'success' :
          element.status == 'Rejected' ? 'error' :
          'warning'">{{ element.status }}</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Action">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Action</mat-header-cell>
        <mat-cell *matCellDef="let element" class="action">
          <a mat-button color="accent" disableRipple [disabled]="!userService.permissionsValue['_CONTRACT_TYPE_EDIT_']"
            [routerLink]="['/app/contract-type', 'edit', element.contractTypeId]"
            matTooltip="Edit Contract Type {{element.name | titlecase}}" [matTooltipShowDelay]="300"
            [matTooltipHideDelay]="100"><ng-icon name="heroPencil"></ng-icon></a>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>

    </mat-table>

    <ng-container *ngIf="dataSource.filter &&  dataSource.filteredData.length === 0">
      <div class="no-data">
        <h4>No Data Found</h4>
        <p>There are no contract types found with <strong>'{{dataSource.filter}}'</strong></p>
      </div>
    </ng-container>

    <ng-container *ngIf="!dataLoading && !dataSource.filter && dataSource.filteredData.length === 0">
      <div class="no-data">
        <h4>No Data Found</h4>
        <p>There are no contract types found!</p>
      </div>
    </ng-container>

    <ng-container *ngIf="dataLoading">
      <div class="skeleton-box">
        <ngx-skeleton-loader [theme]="{height: '200px'}"></ngx-skeleton-loader>
      </div>
    </ng-container>

    <mat-paginator [pageSizeOptions]="[10, 30, 50]" showFirstLastButtons></mat-paginator>
  </div>
</div>